<template>
  <div class="ds-manager__component menu">
    <div class="ds-manager__component-title">
      <r-title type="title-2">
        {{ $t("ds-manager:menu:title") }}
      </r-title>
    </div>
    <div class="ds-manager__component-content">
      <div class="ds-manager__component-subtitle">
        <r-text type="caption"> {{ $t("ds-manager:menu:subtitle") }}</r-text>
      </div>
      <ul class="ds-manager__menu-list">
        <li
          class="ds-manager__menu-list-item"
          v-for="i in menuItems"
          :key="i.id"
          @click="menuClickHandler(i.name)"
        >
          <r-icon
            :name="i.icon"
            :size="14"
            style="width: 16px; margin-right: 8px;"
          ></r-icon>
          <r-text>{{ $t(`ds-manager:menu:item-name:${i.name}`) }}</r-text>
          <i class="r-icon-arrow" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
const menuItems = [
  { id: 1, name: "ds-manager-empty-ds", icon: "layers-folder" },
  { id: 2, name: "ds-manager-empty-model", icon: "model" },
  { id: 3, name: "ds-manager-from-file", icon: "download" }
];

export default {
  props: { menuClickHandler: { type: Function } },
  data() {
    return {
      menuItems
    };
  }
};
</script>

<style lang="scss">
.menu {
  .ds-manager__component-content {
    width: 400px;
    height: 180px;
  }
}
.ds-manager__menu {
  &-list {
    &-item {
      position: relative;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 4px 24px;
      box-sizing: border-box;
      border: 1px solid;
      border-radius: var(--border-radius);
      border-color: var(--dividers_low_contrast) !important;
      height: 40px;
      margin-bottom: 12px;
      transition: all 0.1s ease;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .r-text {
        transition: all 0.1s ease;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .r-icon-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 15px;
        width: 16px;
        transition: all 0.1s ease;
      }
      &:last-child {
        margin-bottom: 0;
      }
      &:hover {
        border-color: var(--accent_primary) !important;
        .r-text {
          color: var(--accent_primary) !important;
        }
        .r-icon-arrow {
          &:before {
            border-color: var(--accent_primary) !important;
          }
          right: 10px;
        }
        .r-icon {
          svg {
            fill: var(--accent_primary) !important;
          }
        }
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "ds-manager:menu:title": "Создать источник данных",
    "ds-manager:menu:subtitle": "Выберите действие:",
    "ds-manager:menu:item-name:ds-manager-empty-ds": "Создать пустой источник данных",
    "ds-manager:menu:item-name:ds-manager-empty-model": "Создать пустую модель данных",
    "ds-manager:menu:item-name:ds-manager-from-file": "Создать источник данных из файла"
  },
  "en": {
    "ds-manager:menu:title": "Create data source",
    "ds-manager:menu:subtitle": "Select an action:",
    "ds-manager:menu:item-name:ds-manager-empty-ds": "Create an empty data source",
    "ds-manager:menu:item-name:ds-manager-empty-model": "Create an empty data model",
    "ds-manager:menu:item-name:ds-manager-from-file": "Create data source from file"
  }
}
</i18n>
